import { faLanguage } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { applicationConfig } from "../../../environmentConfiguration";
import { FeatureCard } from "../../components/Pages/Landing/FeatureCard/FeatureCard";
import { guardWithProps } from "../../components/Routes/Functions/GuardWithProps";
import { lazyRoute } from "../../components/Routes/Functions/LazyRoute";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";

export const translationFeature: IFeature = {
  id: Features.Translation,
  route: {
    path: RouteConstants.Translation,
    lazy: lazyRoute({
      importer: () => import("./TranslationPage"),
      componentName: "TranslationPage",
      guards: [guardWithProps(FeatureGuard, { role: AppRole.TranslationFeature })],
    }),
  },
  menuItem: {
    label: translationKeys.feature.translation.link,
    breadCrumbTitle: translationKeys.feature.translation.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Translation].join("/")}`,
    path: RouteConstants.Translation,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faLanguage} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.Translation}
      requiresBudget={true}
      featureIcon={faLanguage}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Translation}
      disabled={!applicationConfig.featureFlags.enableTranslationFeature}
    />
  ),
  role: AppRole.TranslationFeature,
};
